import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';

const Component = lazy(() => import('components/agri-status-label-tag'));

const AgriStatusLabelTag = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default AgriStatusLabelTag;
